import { isKeyedAddress } from './keyedAddress'

const ignored = ['sample-report', 'referrals', 'referral-verify', 'referral-terms', 'referral-invite']

// Route names may be missing or non-string. Never let optional analytics stop navigation.
export function analyticsView(route) {
  if (!route || typeof route.name !== 'string' || !route.name || isKeyedAddress(route.path) || /^\/referrals(?:\/|$)/.test(route.path || '') || ignored.includes(route.name.toLowerCase())) return null
  return { name: typeof (route.meta || {}).gtm === 'string' ? route.meta.gtm : route.name, path: route.fullPath }
}
